export default __webpack_public_path__ + "static/media/Atlassian Icon.ea39ba68.svg";